<template>
  <div>
    <HeaderComponent  app_title="ECOBUQ" />
    <main>
      <FormEditConfiguration></FormEditConfiguration>
    </main>
    <FooterComponent class="bottom-0"></FooterComponent>

  </div>

</template>

<script>
// @ is an alias to /src
import FooterComponent from '@/components/FooterComponent.vue'
import HeaderComponent from '@/components/HeaderComponent.vue'
import FormEditConfiguration from '@/components/FormEditConfiguration.vue'

export default {
  name: 'HomeView',
  components: {
    HeaderComponent,
    FooterComponent,
    FormEditConfiguration,
  }, created() {
  }
}
</script>
